/* angular:styles/component:css;32b433e73e84727760c2d8ccbb09e2ecba492d020d90c934fb1a693ead0fff5d;/app/src/app/shared/animations/datePicker-component.ts */
.date-picker {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px 12px 16px;
  border-radius: 12px;
  background: #f2f2f2;
  max-height: 56px;
  font-size: 14px;
  font-weight: 400;
  font-family: "Poppins-Regular";
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  gap: 8px;
  width: 100%;
}
.text {
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
}
.grey {
  color: #5c5c5c !important;
}
.dark {
  color: #222;
}
.wide {
  width: 320px;
}
.thin {
  width: 200px;
}
.extra-small {
  font-family: "Poppins-Regular";
  font-size: 12px;
  font-style: normal;
  line-height: 16px;
  color: #222;
  margin: 0;
}
.date-picker-white {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px 12px 16px;
  border-radius: 12px;
  background: #ffffff;
  position: relative;
  z-index: 5;
  max-height: 56px;
  font-size: 14px;
  font-weight: 400;
  font-family: "Poppins-Regular";
  cursor: pointer;
  border: 1px solid #222 !important;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  gap: 8px;
  width: 100%;
}
.custom-datepicker {
  position: absolute;
  z-index: 4;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  border: 1px solid #222;
  margin-top: 4px;
  padding: 16px;
  overflow: hidden;
}
.placement-top {
  top: 0px;
}
.placement-bottom {
  bottom: 52px;
}
.placement-right {
  right: 101%;
}
.placement-zero-right {
  right: 0%;
}
.placement-zero-left {
  left: 0%;
}
.placement-left {
  left: 101%;
}
.placement-top-left {
  top: 0px;
  left: 101%;
}
.placement-top-right {
  top: 0px;
  right: 101%;
}
.placement-bottom-left {
  bottom: 52px;
  left: 101%;
}
.placement-bottom-right {
  bottom: 52px;
  left: 101%;
}
.placement-bottom-just-left {
  right: 0;
}
.header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.image {
  cursor: pointer;
  width: 16px;
  height: 16px;
}
.label {
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #222;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
td {
  width: 36px;
  height: 36px;
  padding: 4px 7px;
  margin: 2px;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
}
.today {
  font-family: "Poppins-Semibold" !important;
  text-decoration: underline !important;
}
td:not(:has(.in-month)):hover {
  cursor: default;
  background: transparent;
}
td:hover {
  border-radius: 8px;
  background: #f2f2f2;
}
.no-hover {
  cursor: default;
}
.no-hover:hover {
  background: transparent;
}
th {
  width: 18px;
  height: 18px;
  margin: 7px 9px;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.br-line {
  height: 90%;
  left: 33px;
  top: 24px;
  width: 1px;
  background: #dfdfdf;
  position: absolute;
  z-index: 2;
}
.button-area {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 8px;
  padding-top: 24px;
}
.calendar {
  position: relative;
  padding-top: 24px;
  overflow: hidden;
}
.week {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Poppins-Regular";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: #a6a6a6;
  margin: 0;
}
.not-in-month {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #a6a6a6;
  margin: 0;
}
.in-month {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #222;
  margin: 0;
}
.first-last-date {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
  background-color: #222 !important;
  color: #fff;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border-top: 1px solid #222;
  border-bottom: 1px solid #222;
}
.first-date {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  background-color: #f2f2f2;
  padding: 0;
}
.last-date {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  background-color: #f2f2f2;
  padding: 0;
}
.white {
  color: #fff !important;
}
.selected {
  background-color: #f2f2f2;
  border-radius: 0px !important;
}
.info-text {
  font-family: "Poppins-Regular";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}
.red-img {
  filter: brightness(0) saturate(100%) invert(61%) sepia(69%) saturate(2913%) hue-rotate(318deg) brightness(89%) contrast(102%);
}
.grey-img {
  filter: brightness(0) saturate(100%) invert(65%);
}
/*# sourceMappingURL=datePicker-component.css.map */
